import * as _ from 'lodash';
import { useState } from 'react';
import { Glyphicon, Row } from 'react-bootstrap';
import { ToDoColumnWrapper } from '../styles';
import { ActionItem } from '../models';
import { IActionCenterOther } from '@nkr/models/index';
import { MainType } from './models/main-type';
import { OrganType } from '@nkr/enums/organ-type';
import ActionCenterItem from './action-center-item';
import ListType from '../list-type';

interface IProps {
    data: IActionCenterOther,
    centerId: number,
    showLoading: boolean,
    hideEmptyItems: boolean,
    organType: OrganType,
    onItemClick: (list: ListType[], mainType: MainType, subType: ActionItem) => void
}

const Other = (props: IProps) => {
    const [expanded, setExpanded] = useState(true);

    const handleItemClick = (list: ListType[], subType: ActionItem) => {
        if (subType == ActionItem.PendingPatientReferrals) {
            window.location.href = `/center/${props.centerId}/action-center/referrals`;
        } else {
            if (subType != ActionItem.Preselects) {
                props.onItemClick(list, MainType.Other, subType);
            } else {
                handlePreselectOutstanding(list, subType);
            }
        }
    };

    const handlePreselectOutstanding = (list: any[], subType: ActionItem) => {
        window.open(`center/${props.centerId}/recipients/donor-pre-select`);
    };

    const logisticsKickoffCalls = props.data != null ? props.data.logisticsKickoffCalls : [];
    const transplantPickups = props.data != null ? props.data.pickups : [];
    const transplantDeliveries = props.data != null ? props.data.deliveries : [];
    const lostChainStarters = props.data != null ? props.data.lostChainStarters : []
    const wageAndTravelRequests = props.data != null ? props.data.wageAndTravelRequests : [];
    const voucherDonors = props.data != null ? props.data.voucherDonors : [];
    // const finalXmResults = props.data != null ? props.data.finalXmResults : [];
    const donorEvalOutOfDate = props.data ? props.data.donorEvalOutOfDate : [];
    const confirmDashDonations = props.data != null ? props.data.confirmDashDonations : [];
    const missingPostTransplantData = props.data != null ? props.data.missingPostTransplantData : [];
    const missingCenterProfileData = props.data != null ? props.data.missingCenterProfileData : [];
    const msPatientsPendingApproval = props.data != null ? props.data.msPatientsPendingApproval : [];
    const passMissingRecipientProfiles = props.data != null ? props.data.passMissingRecipientProfiles : [];

    const show = props.organType == OrganType.Kidney;

    const items = [
        { name: 'Logistics/Kickoff Calls', list: logisticsKickoffCalls, actionItem: ActionItem.LogisticsKickoffCalls, show },
        { name: 'Transplant Pickups', list: transplantPickups, actionItem: ActionItem.TransplantPickup, show },
        { name: 'Transplant Deliveries', list: transplantDeliveries, actionItem: ActionItem.TransplantDelivery, show },
        { name: 'Inactive Donor Verification', list: lostChainStarters, actionItem: ActionItem.LostChainStarters, show },
        { name: 'Wage and Expense Requests', list: wageAndTravelRequests, actionItem: ActionItem.WageAndTravelRequests, show: true },
        { name: 'Voucher Self Registration', list: voucherDonors, actionItem: ActionItem.VoucherDonors, show },
        // { name: 'Upload Final XM Results', list: finalXmResults, actionItem: ActionItem.FinalXmReults, show },
        { name: 'Donor Evals', list: donorEvalOutOfDate, actionItem: ActionItem.DonorEval, show },
        { name: 'Confirm DASH Donations', list: confirmDashDonations, actionItem: ActionItem.ConfirmDashDonations, show: true },
        { name: 'Missing Center Profile Data', list: missingCenterProfileData, actionItem: ActionItem.MissingCenterProfileData, show: true },
        { name: 'Missing Post Transplant Data', list: missingPostTransplantData, actionItem: ActionItem.MissingPostTransplantData, show },
        { name: 'Microsites Pending Approval', list: msPatientsPendingApproval, actionItem: ActionItem.MicrositePatientsPendingApproval, show: true },
        { name: 'Complete Patient Intake', list: passMissingRecipientProfiles, actionItem: ActionItem.PassMissingRecipientProfile, show }
    ];

    const isEmpty = items.filter(x => x.list.length == 0).length == items.length;
    const itemCount = items.filter(x => x.list.length > 0).length;
    const itemList = _.sortBy(items, item => item.name);

    return (
        <div className='section-other'>
            <div className='title-container'>
                <div className='title' style={{ width: '25%' }} onClick={() => setExpanded(!expanded)}>
                    <h4>OTHER <span>({itemCount})</span></h4>
                    <span style={{ paddingLeft: 5 }}><Glyphicon glyph={expanded ? 'chevron-down' : 'chevron-up'} /></span>
                </div>
                <div style={{ borderBottom: '1px solid cadetblue', width: '75%' }}>&nbsp;</div>
            </div>
            {expanded ?
                <div className='content' style={{ flex: '1 1 auto', backgroundColor: props.showLoading ? '#eee' : null, opacity: props.showLoading ? 0.5 : 1 }}>
                    {props.showLoading && (
                        <div className="loader"><div className='message'>Loading other items, one moment please...</div></div>
                    )}

                    <div className='container-fluid'>
                        <Row>
                            {itemList.map((item, index) => {
                                if (((!props.hideEmptyItems && item.list.length == 0) || item.list.length > 0) && item.show) {
                                    return (
                                        <ToDoColumnWrapper key={index} className='col-xs-12 col-lg-6'>
                                            <ActionCenterItem
                                                description={item.name}
                                                list={item.list}
                                                isList={true}
                                                color='black'
                                                highlight='aliceblue'
                                                actionItem={item.actionItem}
                                                onItemClick={handleItemClick}
                                            />
                                        </ToDoColumnWrapper>
                                    )
                                }
                            })}
                        </Row>

                        {isEmpty && props.hideEmptyItems && (
                            <ToDoColumnWrapper className='col-xs-12 col-lg-12' style={{ fontSize: 16 }}>
                                At this time, there are no other items
                            </ToDoColumnWrapper>
                        )}
                    </div>
                </div>
                :
                <div className='content collapsed'></div>
            }
        </div>
    )
}

export default Other;